import { useEffect, useState } from 'react';
import useRaceStore from '../store/raceStore';

/**
 * Custom hook to access race data
 * Initializes the data fetch and provides formatted race data
 * @returns {Object} Formatted race data for UI components
 */
const useRaceData = () => {
  // Get data and methods from the store
  const initialize = useRaceStore(state => state.initialize);
  
  // Local state for formatted data
  const [formattedData, setFormattedData] = useState({
    isLoading: true,
    apiStatus: 'connecting',
    lastUpdate: '',
    position: [41.42283, 41.42973], // Default start position
  });
  
  // Update formatted data when store changes - with debounce for performance
  useEffect(() => {
    // Debounce function to limit updates
    let debounceTimer;
    
    // Function to get formatted data from store
    const updateData = () => {
      // Clear any pending updates
      clearTimeout(debounceTimer);
      
      // Schedule update with debounce
      debounceTimer = setTimeout(() => {
        const data = useRaceStore.getState().getFormattedData();
        setFormattedData(data);
      }, 100); // 100ms debounce
    };
    
    // Subscribe to store changes
    const unsubscribe = useRaceStore.subscribe(updateData);
    
    // Initial data update - immediate
    const data = useRaceStore.getState().getFormattedData();
    setFormattedData(data);
    
    return () => {
      unsubscribe();
      clearTimeout(debounceTimer);
    };
  }, []);
  
  // Initialize data fetch on component mount - tamamen yeni yaklaşım
  useEffect(() => {
    let intervalId;
    
    // Initial data fetch - hemen başlangıçta veri al
    const fetchInitialData = async () => {
      try {
        console.log('Başlangıç verisi alınıyor...');
        await initialize();
        
        // 2 saniye sonra tekrar veri al - ilk yüklemede veri doğruluğunu garantilemek için
        setTimeout(async () => {
          console.log('Doğrulama verisi alınıyor...');
          await useRaceStore.getState().fetchData();
        }, 2000);
      } catch (error) {
        console.error('Başlangıç veri yüklemesi başarısız:', error);
      }
    };
    
    // Periyodik veri güncelleme fonksiyonu - setInterval ile daha güvenilir
    const startPeriodicFetching = () => {
      // Her 15 saniyede bir veri al
      intervalId = setInterval(async () => {
        try {
          console.log('Periyodik veri güncellemesi yapılıyor...');
          await useRaceStore.getState().fetchData();
        } catch (error) {
          console.error('Periyodik veri güncellemesi başarısız:', error);
        }
      }, 15000); // 15 saniye
    };
    
    // Başlangıç verisi al ve periyodik güncellemeyi başlat
    fetchInitialData().then(() => {
      startPeriodicFetching();
    });
    
    // Cleanup function for React
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [initialize]);
  
  return formattedData;
};

export default useRaceData;
